import { useRouter } from 'vue-router';
import { ref, computed, onMounted } from 'vue';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3d950652"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "table-content"
};
const _hoisted_2 = {
  class: "filter-content"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 1,
  class: "my-word-break"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["onClick"];
import { getDomainList } from '@/api/payManage/domian';
import { awaitWrap, OK, reportEvent } from '@/common';
import { usePagination } from '@/hooks/usePagination';
import FormModal from './FormModal.vue';
import DomainDrawer from './DomainDrawer.vue';
import { copy } from '@/common';
export default /*#__PURE__*/_defineComponent({
  __name: 'HostContent',
  emits: ['resetTabs'],
  setup(__props, {
    expose,
    emit
  }) {
    const router = useRouter();
    const dimensionOptions = [{
      label: '支付渠道',
      value: 'pay_chnl',
      title: 'payChnlName'
    }];
    const marketTypeMap = {
      3: 'GP',
      2: 'IOS',
      1: '安卓/小游戏'
    };
    const drawerVisible = ref(false);
    let tabKey = ref('3');
    let isAdd = ref(false);
    let currentItem = ref({});
    // 表格基础字段
    const basicColumns = [{
      title: '账号简称',
      dataIndex: 'accountName',
      key: 'accountName',
      width: '90px'
    }, {
      title: '域名组',
      dataIndex: 'domainGroup',
      key: 'domainGroup',
      width: '90px'
    }, {
      title: '市场类型',
      dataIndex: 'marketType',
      key: 'marketType',
      width: '90px'
    }, {
      title: '开发者网址',
      dataIndex: 'developerUrl',
      key: 'developerUrl'
    }, {
      title: '海外域名',
      dataIndex: 'overseasCallbackUrl',
      key: 'overseasCallbackUrl'
    }, {
      title: '国内域名',
      dataIndex: 'inlandCallbackUrl',
      key: 'inlandCallbackUrl'
    }, {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      width: '120px'
    }];
    const isIos = computed(() => string => {
      return string.toLowerCase().indexOf('ios') !== -1;
    });
    const dataSource = ref([]);
    const columns = ref(basicColumns);
    const dimensionList = ref([]);
    const dimensionTitleList = ref([]);
    const indexList = ref([]);
    const searchForm = ref({});
    const loading = ref(false);
    const activeKey = ref('1');
    const modelVisible = ref(false);
    const openModel = () => {
      modelVisible.value = true;
    };
    const getData = async (searchObj = {}) => {
      let params = {
        pageNum: pageIndex.value,
        // pageSize: pageSize.value,
        pageSize: 3000,
        marketType: Number(tabKey.value)
      };
      params = Object.assign(params, searchObj);
      loading.value = true;
      const startTime = new Date().getTime();
      const [err, data] = await awaitWrap(getDomainList(params));
      if (data && data.code === OK) {
        var _data$data, _data$data2;
        dataSource.value = (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.list;
        pageTotal.value = (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.total;
        reportEvent({
          eventName: '_search',
          properties: {
            ui_name: `域名管理搜索`,
            app_name: '',
            return_duration: new Date().getTime() - startTime,
            query_status: 'succeed'
          }
        });
      }
      if (err) {
        reportEvent({
          eventName: '_search',
          properties: {
            ui_name: `域名管理搜索`,
            app_name: '',
            return_duration: new Date().getTime() - startTime,
            query_status: 'failed'
          }
        });
      }
      loading.value = false;
    };
    const searchData = (searchObj = {}) => {
      pageIndex.value = 1;
      getData(searchObj);
    };
    const changeColumns = () => {
      const arr = ['dateTime', 'appName', 'amount', 'commissionAmount', 'tax', 'refundAmount', 'revenue', 'currency', 'orderAmount', 'refundOrderAmount', ...dimensionTitleList.value, ...indexList.value];
      columns.value = basicColumns.filter(item => arr.includes(item.dataIndex));
      if (activeKey.value === '2') {
        columns.value = [...columns.value, {
          title: '是否可结算',
          dataIndex: 'billStatus',
          key: 'billStatus'
        }];
      }
    };
    const toDetail = (item, type) => {
      if (isIos.value(item.appName)) return;
      let queryObj = {
        dbtId: item.dbtId,
        payChnl: item.payChnl,
        payChnls: searchForm.value.payChnls,
        billType: item.billType,
        datePeriod: searchForm.value.datePeriod,
        startDate: searchForm.value.startDate,
        type
      };
      if (searchForm.value.datePeriod !== 'sum') {
        queryObj = {
          ...queryObj,
          dateTime: item.dateTime
        };
      }
      if (searchForm.value.endDate) {
        queryObj = {
          ...queryObj,
          endDate: searchForm.value.endDate
        };
      }
      router.push({
        name: 'thirdPartyBillDetail',
        query: queryObj
      });
    };
    const resetDimension = key => {
      activeKey.value = key;
      dimensionList.value = [];
      const titles = [];
      dimensionOptions === null || dimensionOptions === void 0 || dimensionOptions.forEach(i => {
        var _dimensionList$value;
        if ((_dimensionList$value = dimensionList.value) !== null && _dimensionList$value !== void 0 && _dimensionList$value.includes(i.value)) {
          titles.push(i.title);
        }
      });
      dimensionTitleList.value = titles;
      pageIndex.value = 1;
      changeColumns();
    };
    const {
      pageIndex,
      pageSize,
      pageTotal
    } = usePagination(() => {});
    // 枚举值定义参考
    const getSettlementText = status => {
      const statusMap = {
        0: '待确认',
        10: '不可结算',
        20: '可结算'
      };
      return status !== undefined ? statusMap[status] || '-' : '-';
    };
    // 渠道变更字段展示调整
    const changeType = () => {
      let arr = ['accountName', 'domainGroup', 'marketType', 'developerUrl', 'overseasCallbackUrl', 'action'];
      if (tabKey.value == '2') {
        arr = ['accountName', 'domainGroup', 'marketType', 'developerUrl', 'inlandCallbackUrl', 'overseasCallbackUrl', 'action'];
      } else if (tabKey.value == '1') {
        arr = ['domainGroup', 'inlandCallbackUrl', 'overseasCallbackUrl', 'action'];
      }
      columns.value = basicColumns.filter(item => arr.includes(item.dataIndex));
      emit('resetTabs', tabKey.value);
    };
    // dataSource 手动分页
    const dataSourceFilter = computed(() => {
      return dataSource.value ? dataSource.value.slice((pageIndex.value - 1) * pageSize.value, pageIndex.value * pageSize.value) : [];
    });
    // 操作按钮方法合集
    const handleColumn = (record, type) => {
      switch (type) {
        case 'edit':
          modelVisible.value = true;
          currentItem.value = record;
          isAdd.value = false;
          break;
        case 'add':
          modelVisible.value = true;
          currentItem.value = {};
          isAdd.value = true;
          break;
        case 'detail':
          drawerVisible.value = true;
          currentItem.value = record;
          reportEvent({
            eventName: 'element_use',
            properties: {
              ui_name: '域名管理查看',
              element_name: '查看'
            }
          });
          break;
      }
    };
    onMounted(() => {
      changeType();
      // changeColumns()
    });
    expose({
      searchData,
      resetDimension
    });
    return (_ctx, _cache) => {
      const _component_a_tab_pane = _resolveComponent("a-tab-pane");
      const _component_a_tabs = _resolveComponent("a-tabs");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_button = _resolveComponent("a-button");
      const _component_SvgIcon = _resolveComponent("SvgIcon");
      const _component_a_table = _resolveComponent("a-table");
      const _component_a_pagination = _resolveComponent("a-pagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_tabs, {
        activeKey: _unref(tabKey),
        "onUpdate:activeKey": _cache[0] || (_cache[0] = $event => _isRef(tabKey) ? tabKey.value = $event : tabKey = $event),
        onChange: changeType,
        class: "my-tabs-style"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_tab_pane, {
          key: "3",
          tab: "GP"
        }), _createVNode(_component_a_tab_pane, {
          key: "2",
          tab: "IOS"
        }), _createVNode(_component_a_tab_pane, {
          key: "1",
          tab: "安卓/小游戏"
        })]),
        _: 1
      }, 8, ["activeKey"]), _unref(tabKey) == '1' ? (_openBlock(), _createBlock(_component_a_button, {
        key: 0,
        type: "primary",
        class: "add-btn",
        onClick: _cache[1] || (_cache[1] = $event => handleColumn(null, 'add'))
      }, {
        icon: _withCtx(() => [_createVNode(_component_svg_icon, {
          "icon-class": "openIcon",
          "class-name": "add-icon"
        })]),
        default: _withCtx(() => [_createTextVNode(" 新增 ")]),
        _: 1
      })) : _createCommentVNode("", true)]), _createVNode(_component_a_table, {
        columns: columns.value,
        "data-source": _unref(dataSourceFilter),
        bordered: "",
        scroll: {
          x: 150 * columns.value.length
        },
        pagination: false,
        loading: loading.value
      }, {
        headerCell: _withCtx(({
          title,
          column
        }) => [column.dataIndex == 'overseasCallbackUrl' ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(tabKey) == '1' ? '国外支付域名' : '海外域名'), 1)) : _createCommentVNode("", true), column.dataIndex == 'inlandCallbackUrl' ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(tabKey) == '1' ? '国内支付域名' : '国内域名'), 1)) : _createCommentVNode("", true)]),
        bodyCell: _withCtx(({
          column,
          record
        }) => [column.dataIndex === 'marketType' ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(marketTypeMap[_unref(tabKey)]), 1)) : _createCommentVNode("", true), ['inlandCallbackUrl', 'overseasCallbackUrl'].includes(column.dataIndex) ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createTextVNode(_toDisplayString(record[column.dataIndex] ? record[column.dataIndex] : '-') + " ", 1), record[column.dataIndex] ? (_openBlock(), _createBlock(_component_SvgIcon, {
          key: 0,
          iconClass: "copy",
          class: "dbt-copyIcon",
          onClick: $event => _unref(copy)(record[column.dataIndex])
        }, null, 8, ["onClick"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), column.dataIndex === 'action' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 2
        }, [_createElementVNode("span", {
          style: {
            "cursor": "pointer",
            "color": "#1677ff"
          },
          onClick: $event => handleColumn(record, 'edit')
        }, "编辑", 8, _hoisted_7), _unref(tabKey) == '1' ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          style: {
            "cursor": "pointer",
            "color": "#1677ff",
            "margin-left": "12px"
          },
          onClick: $event => handleColumn(record, 'detail')
        }, " 查看 ", 8, _hoisted_8)) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["columns", "data-source", "scroll", "loading"]), _createVNode(_component_a_pagination, {
        total: _unref(pageTotal),
        current: _unref(pageIndex),
        "onUpdate:current": _cache[2] || (_cache[2] = $event => _isRef(pageIndex) ? pageIndex.value = $event : null),
        "show-size-changer": "",
        "page-size": _unref(pageSize),
        "onUpdate:page-size": _cache[3] || (_cache[3] = $event => _isRef(pageSize) ? pageSize.value = $event : null),
        "show-total": total => `共 ${total} 条`
      }, null, 8, ["total", "current", "page-size", "show-total"]), _createVNode(FormModal, {
        "is-add": _unref(isAdd),
        "column-item": _unref(currentItem),
        "tab-key": _unref(tabKey),
        "model-visible": modelVisible.value,
        "onUpdate:model-visible": _cache[4] || (_cache[4] = $event => modelVisible.value = $event),
        onRefresh: getData
      }, null, 8, ["is-add", "column-item", "tab-key", "model-visible"]), _createVNode(DomainDrawer, {
        "drawer-visible": drawerVisible.value,
        "onUpdate:drawer-visible": _cache[5] || (_cache[5] = $event => drawerVisible.value = $event),
        ref: "detailRef",
        "column-item": _unref(currentItem)
      }, null, 8, ["drawer-visible", "column-item"])]);
    };
  }
});